export default "__VITE_ASSET__f5ba86a1__"